const list = {
  endOfResult: 'Fin des résultats',
  exportToExcel: 'Exporter en Excel',
};

export default list;
